import { Block, Para, Bullets, Table } from '../print/PrintBlocks';
import { DoDont } from '../DoDont';
import { LivePreview } from '../LivePreview';
import { Badge } from '@/ui/base/badge';
import { STATUS_TONE } from '@/nucleo/statusBadgeTokens';
import { Button } from '@/ui/base/button';
import { formatarRazao, razaoRgb, sobreBranco } from '@/ui/estilos/contraste';
import { lerBloco, paraRgb } from '@/ui/estilos/lerTokens';
import tokensCss from '@/ui/estilos/tokens.css?raw';
import { ItemDaDocumentacao } from '../ItemDaDocumentacao';

/** Texto --success sobre --success a 15% num cartão branco (tema claro), lido de tokens.css. */
const SUCESSO = lerBloco(tokensCss, ':root').get('success')!;
const RAZAO_DO_ANTIPADRAO = formatarRazao(razaoRgb(paraRgb(SUCESSO), sobreBranco(SUCESSO, 0.15)));

export function AcessibilidadeSection() {
  return (
    <div className="space-y-6">
      <ItemDaDocumentacao id="acessibilidade-requisitos">
        <Block>
          <Para>
            Acessibilidade não é etapa final: é critério de aceite. O Sistema TEG segue a WCAG 2.1
            nível AA em ambos os temas, e a auditoria de contraste roda automaticamente antes de
            cada publicação — qualquer par de cores abaixo do mínimo bloqueia a entrega.
          </Para>
          <Table
            head={['Requisito', 'Mínimo', 'Como validamos']}
            rows={[
              ['Contraste de texto', '4,5:1', 'Auditoria automática de tokens no build'],
              [
                'Contraste de elementos de interface',
                '3,0:1',
                'Auditoria automática de tokens no build',
              ],
              ['Área de toque', '44 × 44 px', 'Revisão de telas em 375 px'],
              ['Navegação por teclado', 'Tab, Enter e Espaço', 'Componentes base com foco visível'],
              ['Leitores de tela', 'Rótulos e regiões', 'Rótulos em campos e avisos anunciados'],
            ]}
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="acessibilidade-selos">
        <Block title="Contraste em selos de status">
          <DoDont
            doText="Selos de status usam preenchimento sólido com o texto na cor de contraste correspondente. A leitura permanece confortável em fundo claro e escuro."
            dontText="Fundo colorido translúcido com texto na mesma cor reprova no contraste mínimo e some em telas com brilho baixo."
            doExample={
              <div className="flex flex-wrap gap-2">
                <Badge className={STATUS_TONE.success}>Ativo</Badge>
                <Badge className={STATUS_TONE.warning}>Pendente</Badge>
                <Badge className={STATUS_TONE.destructive}>Rescindido</Badge>
              </div>
            }
            dontExample={
              // O anti-padrão é medido, não pintado: pintá-lo poria na própria
              // documentação a violação que ela descreve.
              <div className="space-y-1 text-xs text-muted-foreground">
                <code className="block font-mono text-foreground">bg-success/15 text-success</code>
                <p>
                  No tema claro, texto --success sobre o próprio --success a 15% dá{' '}
                  <strong className="text-foreground">{RAZAO_DO_ANTIPADRAO}</strong>, abaixo dos
                  4,5:1.
                </p>
              </div>
            }
          />
        </Block>
      </ItemDaDocumentacao>

      <ItemDaDocumentacao id="acessibilidade-foco">
        <Block title="Foco visível e alvo de toque">
          <LivePreview surface="card" themeToggle>
            <div className="flex flex-wrap items-center gap-3">
              <Button>Salvar apontamento</Button>
              <Button variant="outline">Cancelar</Button>
              <Button variant="destructive">Rescindir termo</Button>
            </div>
          </LivePreview>
          <Bullets
            items={[
              'O anel de foco usa o azul de sinalização e nunca é removido — apenas substituído por uma versão mais visível.',
              'Botões têm altura mínima confortável em telas de toque; em mobile os campos crescem automaticamente.',
              'Elementos clicáveis são sempre botões ou links reais, nunca caixas com clique.',
            ]}
          />
        </Block>
      </ItemDaDocumentacao>
    </div>
  );
}
